import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import './UniversityBlock.css';
import React from 'react';
import { get, getMediaHost, injectImageResolution, pathJoin } from "../../utils";
import LazyPicture from "../atoms/LazyPicture/LazyPicture";
import ScrollAnimation from "react-animate-on-scroll";
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as RightArrowSeeMore } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as LeftArrowSeeMore } from '../../resources/icons/IconChevronLeftLight.svg';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
// https://stackoverflow.com/a/27761572
var numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export var UniversityBlock = function UniversityBlock(_ref) {
  var hit = _ref.hit,
    rtl = _ref.rtl,
    _ref$analytics = _ref.analytics,
    analytics = _ref$analytics === void 0 ? {} : _ref$analytics,
    _ref$lang = _ref.lang,
    anualFee = _ref$lang.anualFee,
    visitWebsite = _ref$lang.visitWebsite,
    universityDescription = _ref$lang.universityDescription,
    fieldOfStudy = _ref$lang.fieldOfStudy,
    AED = _ref$lang.AED;
  var image = get(hit, 'image');
  var title = get(hit, 'title');
  var established = get(hit, 'established');
  var numberStudents = get(hit, 'numberStudents');
  var graduatesPerYear = get(hit, 'graduatesPerYear');
  var description = get(hit, 'description');
  var website = get(hit, 'website');
  var universityPrograms = get(hit, 'universityPrograms.programs', []);
  var annualFeeRange = universityPrograms.map(function (_ref2) {
    var annualFee = _ref2.annualFee;
    return annualFee;
  });
  var specializations = universityPrograms.map(function (_ref3) {
    var specialization = _ref3.specialization;
    return specialization;
  });
  var minAnnualFee = Math.min.apply(Math, _toConsumableArray(annualFeeRange));
  var maxAnualFee = Math.max.apply(Math, _toConsumableArray(annualFeeRange));
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), image])), 340, 243);
  var prefix = "".concat(rtl ? '' : AED + ' ');
  var postfix = "".concat(rtl ? ' ' + AED : '');
  var annualFeeValueRange = minAnnualFee === maxAnualFee ? "".concat(prefix).concat(numberWithCommas(minAnnualFee)).concat(postfix) : "".concat(prefix).concat(numberWithCommas(minAnnualFee)).concat(postfix, " - ").concat(prefix).concat(numberWithCommas(maxAnualFee)).concat(postfix);
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12  university__item-col university"
  }, /*#__PURE__*/React.createElement("div", {
    className: "university__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "university__image-wrap",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(analytics.bannerClickAnalytics, analytics.params), title);
    }
  }, hit.image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "university__image",
    src: imgSrc,
    alt: title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "university__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__title",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(analytics.titleClickAnalytics, analytics.params), title);
    }
  }, title), description && description.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__tizer"
  }, description) : universityDescription && /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__tizer"
  }, universityDescription.replace('#universityTitle#', title).replace('#establishedYear#', new Date(established).getFullYear().toString()).replace('#numberStudents#', numberStudents).replace('#graduatesPerYear#', graduatesPerYear).replace('#universityTitle#', title)), specializations.length ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__specializations-field-of-study"
  }, /*#__PURE__*/React.createElement("span", {
    className: "specializations-field-of-study-title"
  }, fieldOfStudy), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "specializations-field-of-study-value"
  }, specializations.join(', '))) : null, annualFeeRange.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "line_indent university__anual-fee"
  }, /*#__PURE__*/React.createElement("span", {
    className: "anual-fee-title"
  }, anualFee), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "anual-fee-value-range"
  }, annualFeeValueRange)) : null, website && visitWebsite && /*#__PURE__*/React.createElement("div", {
    className: "see-more"
  }, /*#__PURE__*/React.createElement("a", {
    className: "see-more-link see-more-link-arrow",
    href: website,
    "aria-label": "Visit Website",
    "aria-labelledby": "Visit Website",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(analytics.visitWebsiteAnalytics, analytics.params), title);
    }
  }, visitWebsite, rtl ? /*#__PURE__*/React.createElement(LeftArrowSeeMore, null) : /*#__PURE__*/React.createElement(RightArrowSeeMore, null))))))));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    minHeight: true,
    className: "".concat(commonStyles)
  }, children);
};
var commonStyles = "c1t568qk";